const validatePhone = (phone: string) => {
  return phone.match(/^[+][0-9][\s]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{4,6}$/im);
};

export default validatePhone;
